import { ApiHandler } from '@eshop/api-client'

import type { Category, CategoryTypes } from '#/local/component/CategoryList'

import { Config } from '#/global/helper/Config'

export const fetchCategoryIdListByQuery = async ({ page, query, type }: { page: number, query: string, type: CategoryTypes }) => {
    const api = new ApiHandler({
        apiEndpoint: 'search',
        path: '/v2/{company}/nodes-{type}/full-search',
        pathParameters: {
            company: Config.getSearchCompany(),
            type,
        },
        parameters: {
            query,
            page: page.toString(),
            items_per_page: '20',
        },
    })

    const result = await api.send<{ items: string[], total_count: number }>()

    const category = result ?? { items: [], total_count: 0 }

    return {
        list: category.items,
        itemsCount: category.total_count,
    }
}

export const fetchCategoryListByIds = async (ids: string[], type: CategoryTypes) => {
    const api = new ApiHandler({
        path: '/product/get-categories-{type}-by-ids',
        pathParameters: {
            type,
        },
        parameters: {
            ids,
        },
    })

    return await api.send<Category[]>() ?? []
}
